import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  productsList: [],
  productDetails: null,
};

export const ProductsSlice = createSlice({
  name: "productsServices",
  initialState,
  reducers: {
    setProductsRecords: (state, action) => {
      state.productsList = action.payload;
    },
    setProductDetails: (state, action) => {
      state.productDetails = action.payload;
    },
  },
});

export const { setProductsRecords, setProductDetails } = ProductsSlice.actions;

export default ProductsSlice.reducer;
